import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const ProfilePage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
        User Profile
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="body1">
            User profile page - coming soon!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfilePage; 